const isNotSelectComponent = (parent: Record<string, any>) => {
  const selectComponents = ['AutoComplete', 'Select', 'MultiSelect'];
  return !selectComponents.includes(parent.instance.$name);
};

export const inputtext = {
  root: ({ props, context, parent }: Record<string, any>) => ({
    class: [
      'basis-80',

      // Font
      'leading-normal',

      // Flex
      { 'flex-1 w-[1%]': parent.instance.$name === 'InputGroup' },

      // Spacing
      'm-0',
      { 'w-full': props.fluid },

      // Size
      {
        'h-12 px-5': props.size === 'large' && isNotSelectComponent(parent),
        'h-10 px-3': props.size === 'small' && isNotSelectComponent(parent),
        'h-11 px-4': props.size == null && isNotSelectComponent(parent),
      },

      // Shape
      { 'rounded-md': parent.instance.$name !== 'InputGroup' },
      {
        'first:rounded-l-md rounded-none last:rounded-r-md': parent.instance.$name === 'InputGroup',
      },
      {
        'border-0 border-y border-l last:border-r': parent.instance.$name === 'InputGroup',
      },
      { 'first:ml-0 -ml-px': parent.instance.$name === 'InputGroup' && !props.showButtons },

      // Colors
      'placeholder:text-grey-400',
      'border',
      { 'border-grey-250': !props.invalid },

      // Invalid State
      { 'border-orange-700': props.invalid },

      // States
      {
        'outline-none text-grey-800 bg-white transition-[border-color,box-shadow] focus:border-transparent focus:shadow-[0_0_0_2px_var(--shadow-color)]':
          !context.disabled,
        'focus:[--shadow-color:_var(--primary)]': !context.disabled && !props.invalid,
        'focus:shadow-orange-700': !context.disabled && props.invalid,
        'text-grey bg-grey-50': context.disabled,
      },

      // Filled State *for FloatLabel
      {
        filled:
          (parent.instance?.$name === 'FloatLabel' && context.filled) ||
          (parent.instance?.$parentInstance?.$name === 'FloatLabel' &&
            parent.props.modelValue !== null &&
            parent.props.modelValue?.length !== 0),
      },

      // Misc
      'appearance-none',
      'duration-200',
    ],
  }),
};
